module.exports = __webpack_public_path__ + "static/media/netlify.b9822dc9.jpg";